export default [

  {
    path: "/policies/policy-change-checklist/draftreviews",
    component: () => import("@/views/pages/policyChangeChecklist.vue"),
    meta: {
      title: "draftreviews",
    },
  },
  {
    path: "/policies/policy-change-checklist/completed",
    component: () => import("@/views/pages/policyChangeChecklist.vue"),
    meta: {
      title: "completed",
    },
  },
  {
    path: "/policies/policy-change-checklist/deleted",
    component: () => import("@/views/pages/policyChangeChecklist.vue"),
    meta: {
      title: "deleted",
    },
  },
];
